import { render, staticRenderFns } from "./ClasificacionVehiculos.vue?vue&type=template&id=581b67ee"
import script from "./ClasificacionVehiculos.vue?vue&type=script&lang=js"
export * from "./ClasificacionVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports